var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-data"},[(_vm.errorMessage === '')?_c('div',[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.errorMessage !== '')?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4578de10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileTabContent.vue
// module id = null
// module chunks = 